// @ts-nocheck
window.addEventListener('wishlistdata', (e)=>{
    let wishlistData = e.detail[0].listcontents;
    let productHandle = [];
    for (let i = 0; i < wishlistData.length; i++) {
        productHandle.push(wishlistData[i].du.split("/products/")[1]);
    }

if(productHandle.length > 0){ 
  document.querySelector('.WI_wishlist_page_empty').style.display = "none";
    productHandle.forEach(async (handel) => {
        try {
            let wishRes = await fetch('/products/'+handel+'?view=cardb');
            let wishData = await wishRes.text();
            let newDiv = document.createElement('div');
            newDiv.classList.add('WI_wishlistProductCard');
            newDiv.innerHTML = wishData;
            let mutdiv = document.querySelector('#wishlist_page_in').appendChild(newDiv);
            document.dispatchEvent(new CustomEvent('imgLoad', { bubbles: true }));
            mutdiv.querySelectorAll('.swym-button').forEach(function (button) {
                button.classList.add('swym-added');
                button.addEventListener("click", function () {
                  const RemoveproductId = button.getAttribute("data-product-id");
                  const RemovevariantId = button.getAttribute("data-variant-id");
                  const RemoveproductUrl = button.getAttribute("data-product-url");
            
                  const product = {
                    empi: RemoveproductId,
                    epi: RemovevariantId,
                    du: RemoveproductUrl,
                  };
                  handleSingleWishlist(product, button);
                  setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 2000);
                  mutdiv.style.display = 'none';

                });
              });
            
        } catch (error) {
            console.log("Error "+error);
            
        }
    });
  }else{
    document.querySelector('.WI_wishlist_page_empty').style.display = "flex";
  }

    async function handleSingleWishlist(product, button) {
        if (!window.globalListArray || !globalListArray[0]) {
          console.warn("Wishlist not ready yet. Try again shortly.");
          return;
        }
      
        const lid = globalListArray[0].lid;
      
        const onSuccess = function () {
          button.classList.toggle("swym-added");
          console.log(
            button.classList.contains("swym-added")
              ? "Product added to wishlist"
              : "Product removed from wishlist"
          );
        };
      
        const onError = function (error) {
          console.log("Error while adding/removing the product", error);
        };
      
        if (!button.classList.contains("swym-added")) { 
          _swat.addToList(lid, product, onSuccess, onError);
          wishPopNoti(product);
        } else {
          _swat.deleteFromList(lid, product, onSuccess, onError); 
        }
      }
});
